import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import { sendPhoneVerificationCode } from 'services/firebaseService';
import { getPhoneAuthErrorMessage } from 'utils/authUtils';
import { VerificationContext } from 'contexts/PhoneVerificationContext';

interface UsePhoneVerificationOptions {
  onSuccess?: (phoneNumber: string) => void;
  navigateToVerification?: boolean;
}

export const usePhoneVerification = (options: UsePhoneVerificationOptions = {}) => {
  const navigate = useNavigate();
  const toast = useToast();
  const { setConfirmationResult } = useContext(VerificationContext);

  const sendVerificationCode = async (
    phoneNumber: string,
    recaptchaLoaded: boolean,
    navigationState?: any
  ) => {
    if (!recaptchaLoaded || !window.recaptchaVerifier) {
      toast({
        title: "Error",
        description: "reCAPTCHA not initialized. Please try again later.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      throw new Error("reCAPTCHA not initialized");
    }

    try {
      const result = await sendPhoneVerificationCode(phoneNumber);
      setConfirmationResult(result);

      if (options.onSuccess) {
        options.onSuccess(phoneNumber);
      }

      if (options.navigateToVerification !== false) {
        navigate('/verification', { state: navigationState });
      }

      return result;
    } catch (error) {
      console.error('Error sending phone verification code:', error);
      toast({
        title: "Error",
        description: getPhoneAuthErrorMessage(error),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      throw error;
    }
  };

  return { sendVerificationCode };
}; 